<template>
  <v-dialog
    v-model="active"
    @click:outside="$emit('close')"
    width="700"
  >
    <v-card>
      <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
      <v-card-title class="d-flex flex-column">
        <h4 class="m-0">Análise do Leite</h4>
        <p class="m-0">Serviço #{{!service.code ? "" : service.code}}</p>
      </v-card-title>
      <v-card-text>
        <div class="col-md-12">
          <the-table 
            :dataItems="computedAnimals"
            :headers="headersForTable"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template> 

<script>
import TheTable from "@/components/layout/TheTable.vue";
export default {
  name: "ModalAnalysis",
  props: {
    active:Boolean,
    service:Object
  },
  components: {
    TheTable
  },
  data() {
    return {
      headersForTable:[
        {text:"Animal", value:"animal_name"},
        {text:"Gordura", value:"fat"},
        {text:"Proteína", value:"protein"},
        {text:"Lactose", value:"lactose"},
        {text:"CCS", value:"ccs"},
        {text:"Observação", value:"classified_comment"},
      ]
    }
  },
  computed: {
    computedAnimals() {
      if(this.service.service_animals) {
        return this.service.service_animals.map(e => ({
          ...e,
          animal_name:e.animal.register + " - " + e.animal.name,
          animal_code:e.animal.code
        }))
      } else {
        return [];
      }
    }
  }
}
</script>

<style scoped>
 .close-icon {
    right: 10px;
    top: 10px;
    position: absolute;
    font-size: 1.3rem;
    cursor: pointer;
  }
</style>